import { AxiosError } from 'axios';
import { monitoringService, MonitoringCategory, MonitoringSeverity } from '../services/monitoringService';

export const extractErrorMessage = (
  error: unknown,
  fallbackMessage = 'An unexpected error occurred.',
): string => {
  if (!error) {
    return fallbackMessage;
  }

  if (typeof error === 'string') {
    return error;
  }

  if ((error as any).message && typeof (error as any).message === 'string') {
    return (error as any).message;
  }

  const axiosError = error as AxiosError<any>;
  if (axiosError?.response?.data) {
    const data = axiosError.response.data as Record<string, any>;
    return (
      data.error ||
      data.message ||
      data.details ||
      fallbackMessage
    );
  }

  return fallbackMessage;
};

interface ReportFormErrorOptions {
  formName: string;
  error?: unknown;
  message?: string;
  fallbackMessage?: string;
  route?: string;
  userEmail?: string;
  userId?: string;
  tags?: string[];
  validationErrors?: Array<{ field: string; message: string }>;
  details?: string;
  severity?: MonitoringSeverity;
  category?: MonitoringCategory;
}

export const reportFormError = (options: ReportFormErrorOptions): void => {
  const derivedMessage =
    options.message ||
    extractErrorMessage(options.error, options.fallbackMessage);

  const route =
    options.route ||
    (typeof window !== 'undefined' ? window.location.pathname : undefined);

  monitoringService
    .reportError({
      message: derivedMessage,
      formName: options.formName,
      route,
      userEmail: options.userEmail,
      userId: options.userId,
      tags: options.tags,
      validationErrors: options.validationErrors,
      details: options.details,
      severity: options.severity,
      category: options.category,
      stack:
        options.error instanceof Error
          ? options.error.stack
          : typeof options.error === 'string'
          ? options.error
          : undefined,
    })
    .catch((monitorError) => {
      console.error('Failed to report form error:', monitorError);
    });
};
